module.exports = __webpack_public_path__ + "img/SDOREE.9f92bc5c.svg";